import { IconProp } from '@fortawesome/fontawesome-svg-core';

export type AssistanceIconConfig = {
  icon: IconProp;
  background: string;
  color: string;
};

const DEFAULT_ICON: AssistanceIconConfig = { icon: ['far', 'car-wrench'], background: '#ffe9cc', color: '#f7941d' };

// Palabras clave (sin tildes, en minúsculas) de la avería, su ícono y colores de fondo/texto asociados.
const ICONS_BY_KEYWORD: ({ keywords: string[] } & AssistanceIconConfig)[] = [
  { keywords: ['00000001'], icon: ['far', 'car-on'], background: '#FDECED', color: '#EA3E4F' },
  { keywords: ['00000007'], icon: ['fal', 'puzzle'], background: '#EFF0F2', color: '#62656A' },
  { keywords: ['00000014'], icon: ['far', 'car-battery'], background: '#FFF8DA', color: '#B8920A' },
  { keywords: ['00000016'], icon: ['fas', 'steering-wheel'], background: '#E8E6FB', color: '#5B4FCF' },
  { keywords: ['00000019'], icon: ['far', 'gear-complex'], background: '#FFE9CC', color: '#F7941D' },
  { keywords: ['00000039'], icon: ['far', 'car-bolt'], background: '#D3EFFF', color: '#0094D9' },
  { keywords: ['00000038'], icon: ['far', 'tire'], background: '#E4E7EB', color: '#35373C' },
  { keywords: ['00000037'], icon: ['far', 'car-key'], background: '#F9E4F3', color: '#C0399B' },
  { keywords: ['00000006'], icon: ['far', 'gas-pump'], background: '#D5FCE7', color: '#13B966' },
  { keywords: ['00000055'], icon: ['fas', 'arrows-left-right'], background: '#D8F3F3', color: '#128C8C' },
];

export const getAssistanceIcon = (averia?: string): AssistanceIconConfig => {
  if (!averia) return DEFAULT_ICON;

  const match = ICONS_BY_KEYWORD.find(({ keywords }) => keywords.some((keyword) => averia === keyword));

  return match ?? DEFAULT_ICON;
};
